let NecrocomicheCharacters = [
    {
        characterName: 'Araya',
        gender: '♀',
        height: 163,
        position: "윤회전생구제소 소속 고참 공무원.",
        description: ["명계에서 중생의 윤회를 돕고 있다. 오랫동안 중역이었어서 발이 넓고 인망도 좋다. ",
            "소문으로는 가능함에도 열반에 들지 않고 구제소에서 계속 일하고 있다고. ",
            "죽은지 오래됐지만 아직 하계에, 특히 문화에 관심이 많아 음악이나 영화 등을 자주 챙겨본다. ",
            "어차피 없어질 생명에 애착을 갖고, 슬픔이나 두려움을 느끼고 있기에, ",
            "아직은 나도 인간이구나, 라고 느끼고 있다."
        ],
        imageOffset: {x: 0, y: -10}
    },
    {
        characterName: 'Kei',
        gender: '♂',
        height: 175,
        position: "윤회전생구제소 소속 사회복무요원. 불량선인.",
        description: ["생전에 지은 죄가 많아 사회봉사형을 받아, 공무원 일을 돕고 있다. ",
            "사무실에 오래 앉아있질 못하고, 훌쩍 어디론가 떠나 낮잠을 자곤 하는 바람에 ",
            "그냥 외근 업무 전담이 되었다. 그쪽이 적성에도 잘 맞아서 만족하고 있다. ",
            "근태 문제로 남은 봉사 시간이 줄어들 생각을 안 하지만, ",
            "본인은 마음에 드는 누님한테 들러붙을 수 있으니 아무래도 좋다."
        ],
        imageOffset: {x: 0, y: 0}
    },
    {
        characterName: 'Myu',
        gender: '♀',
        height: 161,
        position: "현세의 무당.",
        description: ["살아있는 인간. 점쟁이. 손님이 별로 없어서 가난하다. ",
            "명계의 일을 조금씩 돕고 있으며, 저승과 이승을 오락가락하고 있다. ",
            "사실은 인간보단 저쪽 세상 사람들 편이라, 곧잘 액이나 저주를 씌워버리곤 한다. ",
            "그게 영업에 타격을 주는 것 같지만, 그다지 상관 없다. ",
            "믿음직하고 든든해 보이지만, 사실 자기 문제를 혼자서 해결하려들 뿐. "
        ],
        imageOffset: {x: 0, y: 0}
    },
    {
        characterName: 'Dok',
        gender: '♂',
        height: 172,
        position: "경계의 방랑 구제사.",
        description: ["인간이 영적인 위기에 빠졌을 때 나타나 잠깐 돕고 사라지는 존재. ",
            "버려진 사찰을 거점으로 현세 이곳저곳을 떠돌아다니고 있다. ",
            "어릴적 무언가의 저주를 받아 저승에 머물 수 없게 되었고, ",
            "현세에서도 버려진 곳을 벗어날 수 없게 되었다. ",
            "자신을 키워준 누나(?)의 연으로, 윤회전생구제소에도 출입하고 있다. "
        ],
        imageOffset: {x: 0, y: -10}
    },
    {
        characterName: 'XXX',
        gender: '♂',
        height: 173,
        position: "번뇌자.",
        description: ["이것저것 포기하고 절망한 끝에 윤회를 벗어난 인간. ",
            "그뿐이지 죄가 많고, 괴로움도 많고, 기억도 많아서 아직 명계에 갇혀있다. ",
            "특별히 시킨 것도 아니지만, 아들이었던 녀석?이랑 비슷하게 외근 임무를 도맡아 하고 있다. ",
            "사람을 많이 보는 게 괴로워서 그런데, 막상 그를 따라 저승길에 오른 사람들의 평가는 좋다. ",
            "고양이를 보면 그냥 못 지나친다. "
        ],
        imageOffset: {x: 0, y: 0}
    },
];

export default NecrocomicheCharacters;